import { Box, Typography } from "@drone-js/core";
import { FloatingNotification, type FloatingNotificationProps } from "apps/commons/components/FloatingNotification";
import { Fragment, type FunctionComponent } from "react";
import { useStaticDataAtomValue } from "../staticDataAtom";

export const RequirementNotMetNotification: FunctionComponent<
    Pick<FloatingNotificationProps, "visible" | "onClose">
> = (props) => {
    const {
        cmsData: {
            photo: { makeSureTheyMeetTheseRequirements, minimumSize, maximumSize, format, somePhotosWereNotAdded },
        },
    } = useStaticDataAtomValue();

    let content = Object.assign(
        {},
        <Fragment>
            <Typography variant="body-s">{makeSureTheyMeetTheseRequirements}</Typography>
            <Box as="ul" m="0" ps="16">
                <li>
                    <Typography variant="body-s">{minimumSize}</Typography>
                </li>
                <li>
                    <Typography variant="body-s">{maximumSize}</Typography>
                </li>
                <li>
                    <Typography variant="body-s">{format}</Typography>
                </li>
            </Box>
        </Fragment>,
        {
            split: () => ({
                length: 18,
            }),
        },
    );

    return (
        <FloatingNotification
            intent="error"
            icon="fill.symbol.triangle-exclamation"
            title={somePhotosWereNotAdded}
            description={content}
            {...props}
        />
    );
};
